import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputLabel, Input, RadioLabel } from '@weezevent/nacre';

import css from '../../conditions.module.css';

const FormInputCondition = ({ condition, handleCondition }) => {
    const { t } = useTranslation();

    return (
        <>
            <div>
                <RadioLabel bordered inline checked={condition.form_type === 'attendee'} value="attendee" onChange={({ target: { value } }) => handleCondition('form_type', value)}>
                    {t('ticket.moderation.statusesTransitions.transition.steps.actions.recipientAttendeeOption')}
                </RadioLabel>
                <RadioLabel bordered inline checked={condition.form_type === 'buyer'} value="buyer" onChange={({ target: { value } }) => handleCondition('form_type', value)}>
                    {t('ticket.moderation.statusesTransitions.transition.steps.actions.recipientBuyerOption')}
                </RadioLabel>
            </div>

            <div className={css['conditions-card-input']}>
                <InputLabel label={t('ticket.moderation.statusesTransitions.conditions.detail.conditionRules.form.source')} />
                <Input
                    name="sender"
                    placeholder={t('ticket.moderation.statusesTransitions.conditions.detail.conditionRules.form.source')}
                    onChange={({ target: { value } }) => handleCondition('source', value)}
                    value={condition.source}
                />
            </div>

            <div className={css['conditions-card-input']}>
                <InputLabel label={t('ticket.moderation.statusesTransitions.conditions.detail.conditionRules.form.rule')} />
                <Input
                    name="mailTemplate"
                    placeholder={t('ticket.moderation.statusesTransitions.conditions.detail.conditionRules.form.rule')}
                    onChange={({ target: { value } }) => handleCondition('regex', value)}
                    value={condition.regex}
                />
            </div>
        </>
    );
};

export default FormInputCondition;
